import { render, staticRenderFns } from "./DemandDetail.vue?vue&type=template&id=297ac0b6&scoped=true"
import script from "./DemandDetail.vue?vue&type=script&lang=js"
export * from "./DemandDetail.vue?vue&type=script&lang=js"
import style0 from "./DemandDetail.vue?vue&type=style&index=0&id=297ac0b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297ac0b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VList,VListItem,VToolbar})
